var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8327 11.5C11.3962 11.5 10.0184 10.9293 9.00259 9.91352C7.98676 8.89769 7.41608 7.51994 7.41608 6.08335C7.41608 4.64676 7.98676 3.26901 9.00259 2.25319C10.0184 1.23737 11.3962 0.666687 12.8327 0.666687C14.2693 0.666687 15.6471 1.23737 16.6629 2.25319C17.6787 3.26901 18.2494 4.64676 18.2494 6.08335C18.2494 7.51994 17.6787 8.89769 16.6629 9.91352C15.6471 10.9293 14.2693 11.5 12.8327 11.5ZM19.3327 16.9167V22.3334H17.1661V16.9167C17.1661 12.0948 20.0304 7.94127 24.1503 6.06602L25.0473 8.03769C23.3429 8.8129 21.8977 10.0624 20.8844 11.6369C19.871 13.2114 19.3324 15.0443 19.3327 16.9167ZM8.49941 16.9167V22.3334H6.33275V16.9167C6.33291 15.0445 5.79414 13.2118 4.7808 11.6375C3.76746 10.0632 2.32239 8.81391 0.618164 8.03877L1.51516 6.06602C3.59807 7.01339 5.36425 8.54031 6.60274 10.4644C7.84123 12.3885 8.49967 14.6285 8.49941 16.9167Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportive);
export default __webpack_public_path__ + "static/media/supportive.766e92a24670ca389f39b09e2d51c62b.svg";
export { ForwardRef as ReactComponent };